<template>
<section>
<div class="container" v-if="addOns.questionnaires">
    <div class="hero is-bold">
        <div class="hero-body" style="padding-left: 0px; padding-top: 0px">
            <div class="container">
                <h1 class="title" style="color:#3e8ed0">Questionnaire Analytics</h1>
                <h5 class="subtitle">Statistics for your questionnaires.</h5>
            </div>
        </div>
    </div>
    <div class="columns is-multiline is-mobile">

        <div class="column is-3 is-offset-1">
            <b-field label="Date Range:">
                <b-datepicker placeholder="Click to select..." v-model="dates" range>
                </b-datepicker>
            </b-field>
        </div>

        <div class="column is-4 is-offset-0">
            <b-field label="Device:">
                <b-select v-model="selectedDevice">
                    <option value="all">All devices</option>
                    <option v-for="(device, id) in devices" :key="id" :value="id">{{ device.name }}</option>
                </b-select>
            </b-field>
        </div>
        </div>
        <div class="columns is-multiline is-mobile">
        <div class="column is-3 is-offset-1">
            <b-field label="Questionnaire:">
                <b-select v-model="selectedQuestionnaire">
                    <option v-for="(questionnaire, id) in questionnaires" :key="id" :value="id">
                        {{ questionnaire.name }}</option>
                </b-select>
            </b-field>
        </div>

        <div v-if="selectedQuestionnaire !== ''" class="column is-4 is-offset-0">
            <b-field label="Questions:">
                <b-select v-model="selectedQuestion">
                    <option v-for="(q, id) in questions" :key="id" :value="id">{{ q.text }}</option>
                </b-select>
            </b-field>
        </div>
    </div>
    <GChart v-if="chartData.length > 0" :type="chartType" :data="chartData" :options="chartOptions" />

    <div class="columns is-multiline is-mobile">

        <!--<div class="column is-3 is-offset-1" >
<b-button type="is-info">
<download-excel :data="exportData" :fields="jsonFields" name="CustomerSatisfaction.csv" type="csv" :escapeCsv="falseString">
        Export Data
        </download-excel>
</b-button>
</div>-->
    </div>
</div>
<div v-else class="container">
</div>
</section>
</template>

<script>
import { GChart } from 'vue-google-charts'

export default {
  name: 'QuestionnaireAnalytics',
  data: () => {
    return {
      resultsArray: [],
      dates: [],
      selectedQuestionnaire: '',
      selectedQuestion: '',
      selectedDevice: 'all',
      questions: {},
      exportData: null,
      falseString: false,
      jsonFields: {
        'Device': 'device',
        'Front desk': 'frontDesk',
        'Time': 'time',
        'Rating': 'rating'
      },
      chartData: [],
      chartType: 'ColumnChart',
      chartOptions: {
        width: 1100,
        height: 400,
        fontName: 'Nunito',
        title: '',
        is3D: true,
        bar: { groupWidth: '90%' },
        vAxis: { format: '0' },
        yAxis: {
          viewWindow: {
            min: 0
          }
        }
      }
    }
  },
  components: {
    GChart
  },
  computed: {
    questionnaireAnswers () {
      return this.$store.state.questionnaireAnswers
    },
    questionnaires () {
      return this.$store.state.questionnaires
    },
    addOns () {
      return this.$store.state.addOns
    },
    devices () {
      return this.$store.state.devices
    }
  },
  watch: {
    dates () {
      let startDateArray = this.dates[0].toLocaleDateString('en-GB').split('/')
      let startD = new Date(startDateArray[2], parseInt(startDateArray[1]) - 1, startDateArray[0])
      let endDateArray = this.dates[1].toLocaleDateString('en-GB').split('/')
      let endD = new Date(endDateArray[2], parseInt(endDateArray[1]) - 1, endDateArray[0])

      if (this.selectedQuestionnaire !== '' && this.selectedQuestion !== '') {
        if (this.selectedDevice === 'all') {
          this.calculateChartData(startD, endD, this.selectedQuestionnaire, this.selectedQuestion)
        } else {
          this.calculateChartDataByDevice(startD, endD, this.selectedQuestionnaire, this.selectedQuestion, this.selectedDevice)
        }
      }
    },
    selectedQuestionnaire () {
      this.chartData = []
      this.selectedQuestion = ''

      this.getQuestionsByQuestionnaire(this.selectedQuestionnaire)
    },
    selectedQuestion () {
      let startDateArray = this.dates[0].toLocaleDateString('en-GB').split('/')
      let startD = new Date(startDateArray[2], parseInt(startDateArray[1]) - 1, startDateArray[0])
      let endDateArray = this.dates[1].toLocaleDateString('en-GB').split('/')
      let endD = new Date(endDateArray[2], parseInt(endDateArray[1]) - 1, endDateArray[0])

      if (this.selectedQuestionnaire !== '' && this.selectedQuestion !== '') {
        if (this.selectedDevice === 'all') {
          this.calculateChartData(startD, endD, this.selectedQuestionnaire, this.selectedQuestion)
        } else {
          this.calculateChartDataByDevice(startD, endD, this.selectedQuestionnaire, this.selectedQuestion, this.selectedDevice)
        }
      }
    },
    selectedDevice () {
      let startDateArray = this.dates[0].toLocaleDateString('en-GB').split('/')
      let startD = new Date(startDateArray[2], parseInt(startDateArray[1]) - 1, startDateArray[0])
      let endDateArray = this.dates[1].toLocaleDateString('en-GB').split('/')
      let endD = new Date(endDateArray[2], parseInt(endDateArray[1]) - 1, endDateArray[0])

      if (this.selectedQuestionnaire !== '' && this.selectedQuestion !== '') {
        if (this.selectedDevice === 'all') {
          this.calculateChartData(startD, endD, this.selectedQuestionnaire, this.selectedQuestion)
        } else {
          this.calculateChartDataByDevice(startD, endD, this.selectedQuestionnaire, this.selectedQuestion, this.selectedDevice)
        }
      }
    }
  },
  mounted: function () {
    var start = new Date()
    var end = new Date()
    start.setDate(start.getDate() - 6)
    end.setDate(end.getDate())
    this.dates = [start, end]
  },
  methods: {
    calculateChartData (startD, endD, qtnr, qtr) {
      let questionOptions = []
      let questionnaireRef = Object.assign({}, this.questionnaires[qtnr])
      let questionsRef = questionnaireRef.questions
      if (questionsRef) {
        for (let questionId in questionsRef) {
          if (questionId === qtr) {
            let question = questionsRef[questionId]
            let options = Object.keys(question.options).map(key => ({ id: Number(key), ...question.options[key] }))
            for (let optionId in options) {
              questionOptions.push({
                optionId: options[optionId].id,
                optionName: options[optionId].text
              })
            }
            break
          }
        }
      }
      let resultsArray = []
      for (let questionOption in questionOptions) {
        resultsArray[questionOptions[questionOption].optionId] = 0
      }
      if (this.questionnaireAnswers) {
        for (let deviceId in this.questionnaireAnswers) {
          let questionnaires = this.questionnaireAnswers[deviceId]
          for (let questionnaireId in questionnaires) {
            if (questionnaireId === qtnr) {
              let questions = questionnaires[questionnaireId]
              for (let questionId in questions) {
                if (questionId === qtr) {
                  let answers = questions[questionId]
                  for (let answerId in answers) {
                    let answer = answers[answerId]
                    let date = answerId.split(' ')[0]
                    let dateArray = date.split('-')
                    let dateD = new Date(dateArray[2], parseInt(dateArray[1]) - 1, dateArray[0])
                    if (dateD >= startD && dateD <= endD) {
                      for (let questionOption in questionOptions) {
                        if (questionOptions[questionOption].optionId === answer.option.id && questionOptions[questionOption].optionName === answer.option.text) {
                          resultsArray[questionOptions[questionOption].optionId] += 1
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
      let chD = [['Answer option', 'No. of answers']]

      for (let res in resultsArray) {
        let resName = questionOptions.filter(x => x.optionId === res)[0].optionName
        chD.push([resName, resultsArray[res]])
      }
      this.chartData = chD
      this.globalLogger(this.questions, 'zaneta')
      if (this.questions[this.selectedQuestion] !== undefined) {
        if (startD.getTime() === endD.getTime()) {
          this.chartOptions.title = this.questions[this.selectedQuestion].text + ', All devices, ' + startD.toLocaleDateString('en-GB')
        } else {
          this.chartOptions.title = this.questions[this.selectedQuestion].text + ', All devices, ' + startD.toLocaleDateString('en-GB') + ' - ' + endD.toLocaleDateString('en-GB')
        }
      }
    },
    calculateChartDataByDevice (startD, endD, qtnr, qtr, dev) {
      let questionOptions = []
      let questionnaireRef = Object.assign({}, this.questionnaires[qtnr])
      let questionsRef = questionnaireRef.questions
      if (questionsRef) {
        for (let questionId in questionsRef) {
          if (questionId === qtr) {
            let question = questionsRef[questionId]
            let options = Object.keys(question.options).map(key => ({ id: Number(key), ...question.options[key] }))
            for (let optionId in options) {
              questionOptions.push({
                optionId: options[optionId].id,
                optionName: options[optionId].text
              })
            }
            break
          }
        }
      }
      let resultsArray = []
      for (let questionOption in questionOptions) {
        resultsArray[questionOptions[questionOption].optionId] = 0
      }
      if (this.questionnaireAnswers) {
        for (let deviceId in this.questionnaireAnswers) {
          if (deviceId === dev) {
            let questionnaires = this.questionnaireAnswers[deviceId]
            for (let questionnaireId in questionnaires) {
              if (questionnaireId === qtnr) {
                let questions = questionnaires[questionnaireId]
                for (let questionId in questions) {
                  if (questionId === qtr) {
                    let answers = questions[questionId]
                    for (let answerId in answers) {
                      let answer = answers[answerId]
                      let date = answerId.split(' ')[0]
                      let dateArray = date.split('-')
                      let dateD = new Date(dateArray[2], parseInt(dateArray[1]) - 1, dateArray[0])
                      if (dateD >= startD && dateD <= endD) {
                        for (let questionOption in questionOptions) {
                          if (questionOptions[questionOption].optionId === answer.option.id && questionOptions[questionOption].optionName === answer.option.text) {
                            resultsArray[questionOptions[questionOption].optionId] += 1
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
      let chD = [['Answer option', 'No. of answers']]

      for (let res in resultsArray) {
        let resName = questionOptions.filter(x => x.optionId === res)[0].optionName
        chD.push([resName, resultsArray[res]])
      }
      this.chartData = chD

      let deviceName = this.$store.getters.getDeviceName(this.selectedDevice)
      if (this.questions[this.selectedQuestion] !== undefined) {
        if (startD.getTime() === endD.getTime()) {
          this.chartOptions.title = this.questions[this.selectedQuestion].text + ', ' + deviceName + ', ' + startD.toLocaleDateString('en-GB')
        } else {
          this.chartOptions.title = this.questions[this.selectedQuestion].text + ', ' + deviceName + ', ' + startD.toLocaleDateString('en-GB') + ' - ' + endD.toLocaleDateString('en-GB')
        }
      }
    },
    getQuestionsByQuestionnaire (questionnaireId) {
      let questionnaireRef = Object.assign({}, this.questionnaires[questionnaireId])
      this.questions = {}
      let questionsRef = questionnaireRef.questions
      if (questionsRef) {
        for (let question in questionsRef) {
          this.questions[question] = questionsRef[question]
        }
      }
    }
  }
}
</script>
    <style scoped>
    .topPadding {
    padding-top: 14px
    }
    </style>



// WEBPACK FOOTER //
// src/components/questionnaireanalytics/QuestionnaireAnalytics.vue